import React, { FC, SetStateAction } from 'react'

import { Check } from '@Assets/SVG'
import { SmallPersonalizationButton } from '@Components/AddedToCartModal/styledElements'
import { ProductTile } from '@Components/Product/Tile'
import { Product as ProductMParticle } from '@Events/ECommerce'
import { Product as ProductGTM } from '@Globals/Google/DataLayer'
import { useTranslation } from '@Globals/Translations'

interface Props {
  personalization: {
    hasBeenRecentlyAdded: boolean
    id: string | number
    image: string
    price: string
    title: string
    type: string
  }
  setModalState: SetStateAction<any>
}

export const PersonalizationCrossSells: FC<Props> = ({
  personalization: {
    hasBeenRecentlyAdded,
    id,
    image,
    price,
    title,
    type,
  },
  setModalState,
}) => {
  const { t } = useTranslation()

  // TODO add gtm and mparticle
  return (
    <>
      <ProductTile
        greyOverlay
        gtmProduct={{} as ProductGTM}
        id={id.toString()}
        mParticleProduct={{} as ProductMParticle}
        personalization
        price={price}
        primaryImage={image}
        title={t(title)}
        url=""
      />
      <SmallPersonalizationButton
        disabled={hasBeenRecentlyAdded}
        onClick={() => {
          setModalState(prevState => ({
            ...prevState,
            currentModal: type,
          }))
        }}
        size="small"
        variant="outlined"
      >
        {hasBeenRecentlyAdded ? <Check height={16} width={16} /> : t('cms:COF_SELECT')}
      </SmallPersonalizationButton>
    </>
  )
}

